import {
  STORE_NEW_BLOCKED_USER,
  BlockedState,
  BlockedActionType,
  SET_IS_FETCHING_LIST,
  STORE_DISMISSED_PROFILES,
  UPDATE_DISMISSED_PROFILES,
  UPDATE_BLOCKED_PROFILES,
  SET_DELETED_LOADER,
} from './types/Blocked.d';
import { isEmpty } from 'lodash';

const initialState: BlockedState = {
  howManyPagesLoaded: 1,
  blockedItems: [],
  dismissedProfiles: [],
  isFetchingProfileList: false,
  isDeletedLoader: false,
  pagination: null,
  dismissedPagination: null,
};

const blocked = (state = initialState, action: BlockedActionType): any => {
  switch (action.type) {
    case STORE_NEW_BLOCKED_USER: {
      const updatedBlockedItems = !isEmpty(action.payload)
        ? action.payload?.meta.pagination?.current_page === 1
          ? action.payload.data
          : state.blockedItems.concat(action.payload.data)
        : [];

      return {
        ...state,
        blockedItems: updatedBlockedItems,
        pagination: action?.payload?.meta?.pagination || null,
      };
    }

    case UPDATE_DISMISSED_PROFILES: {
      return {
        ...state,
        dismissedProfiles: action.payload,
      };
    }

    case UPDATE_BLOCKED_PROFILES: {
      return {
        ...state,
        blockedItems: action.payload,
      };
    }

    case STORE_DISMISSED_PROFILES: {
      const updatedDismissedUser = !isEmpty(action.payload)
        ? action.payload?.meta.pagination?.current_page === 1
          ? action.payload.data
          : state.dismissedProfiles.concat(action.payload.data)
        : [];

      return {
        ...state,
        dismissedProfiles: updatedDismissedUser,
        dismissedPagination: action?.payload?.meta?.pagination || null,
      };
    }

    case SET_IS_FETCHING_LIST:
      return {
        ...state,
        isFetchingProfileList: action.payload,
      };

    case SET_DELETED_LOADER:
      return {
        ...state,
        isDeletedLoader: action.payload,
      };

    default:
      return state;
  }
};

export default blocked;
